export default {
  path: '/companies',
  name: 'Companies',
  component: () => import(/* webpackChunkName: "base" */ '../views/CompaniesView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
